import { type NextRouter } from 'next/router'
import { type TFunction } from 'next-i18next'
import qs from 'query-string'

import { getSrpComposedUrl } from '@/domain/srp/getSrpComposedUrl'
import { CAR_BODY_TYPE_VALUES } from '@/features/attributes/constants/attributes'
import {
  addAttributeParamToUrl,
  AttributeType,
} from '@/features/search/utils/vertical-brp/addAttributeParamToUrl'

type BodyTypeData = {
  imgSrc: string
  label: string
  url: string
}

const { PICKUP_TRUCK, SEDAN, SUV_CROSSOVER, VAN, CONVERTIBLE, HATCHBACK, WAGON, COUPE } =
  CAR_BODY_TYPE_VALUES

/**
 * Body types in order to appear in the vertical BRP
 */
export const BROWSE_BY_BODY_TYPE = [
  PICKUP_TRUCK,
  SEDAN,
  SUV_CROSSOVER,
  VAN,
  CONVERTIBLE,
  HATCHBACK,
  WAGON,
  COUPE,
]

export const getBrowseByBodyTypeData = (
  t: TFunction,
  routerQuery: NextRouter['query']
): BodyTypeData[] => {
  const currUrl = getSrpComposedUrl(routerQuery)
  const { query } = qs.parseUrl(currUrl.href)

  return BROWSE_BY_BODY_TYPE.map((canonicalName) => {
    const i18nLabelKey = `srp:search_by_body_type.${canonicalName}.label`
    const imgSrc = `/next-assets/images/autos-body-type/${canonicalName}.png`
    const seoUrl = addAttributeParamToUrl(AttributeType.BODY_TYPE, currUrl.href, [canonicalName], t)

    return { label: t(i18nLabelKey), imgSrc: imgSrc, url: qs.stringifyUrl({ url: seoUrl, query }) }
  })
}
